<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 25C5.5975 25 0 19.4025 0 12.5C0 5.5975 5.5975 0 12.5 0C19.4025 0 25 5.5975 25 12.5C25 19.4025 19.4025 25 12.5 25Z"
      fill="#104375"
    />
    <path
      d="M12.5 5.505C14.7775 5.505 15.0475 5.5125 15.9475 5.555C16.78 5.5925 17.2325 5.7325 17.5325 5.85C17.93 6.005 18.215 6.19 18.5125 6.4875C18.81 6.785 18.995 7.07 19.15 7.4675C19.2675 7.7675 19.405 8.22 19.445 9.0525C19.485 9.9525 19.495 10.2225 19.495 12.5C19.495 14.7775 19.4875 15.0475 19.445 15.9475C19.4075 16.78 19.2675 17.2325 19.15 17.5325C18.995 17.93 18.81 18.215 18.5125 18.5125C18.215 18.81 17.93 18.995 17.5325 19.15C17.2325 19.2675 16.78 19.405 15.9475 19.445C15.0475 19.485 14.7775 19.495 12.5 19.495C10.2225 19.495 9.95253 19.4875 9.05253 19.445C8.22003 19.4075 7.76753 19.2675 7.46753 19.15C7.07003 18.995 6.78503 18.81 6.48753 18.5125C6.19003 18.215 6.00503 17.93 5.85003 17.5325C5.73253 17.2325 5.59503 16.78 5.55503 15.9475C5.51503 15.0475 5.50503 14.7775 5.50503 12.5C5.50503 10.2225 5.51253 9.9525 5.55503 9.0525C5.59253 8.22 5.73253 7.7675 5.85003 7.4675C6.00503 7.07 6.19003 6.785 6.48753 6.4875C6.78503 6.19 7.07003 6.005 7.46753 5.85C7.76753 5.7325 8.22003 5.595 9.05253 5.555C9.95253 5.5125 10.2225 5.505 12.5 5.505ZM12.5 3.9675C10.1825 3.9675 9.89253 3.9775 8.98253 4.02C8.07503 4.0625 7.45503 4.205 6.91003 4.4175C6.35003 4.6325 5.87253 4.925 5.40003 5.4C4.92503 5.875 4.63503 6.35 4.41503 6.9125C4.20503 7.455 4.06003 8.075 4.01753 8.985C3.97503 9.895 3.96503 10.185 3.96503 12.5025C3.96503 14.82 3.97503 15.11 4.01753 16.02C4.06003 16.9275 4.20253 17.5475 4.41503 18.0925C4.63253 18.65 4.92503 19.1275 5.40003 19.6C5.87503 20.075 6.35003 20.365 6.91253 20.585C7.45503 20.795 8.07503 20.94 8.98503 20.9825C9.89503 21.025 10.185 21.035 12.5025 21.035C14.82 21.035 15.11 21.025 16.02 20.9825C16.9275 20.94 17.5475 20.7975 18.0925 20.585C18.65 20.3675 19.1275 20.075 19.6 19.6C20.075 19.125 20.365 18.65 20.585 18.0875C20.795 17.545 20.94 16.925 20.9825 16.015C21.025 15.105 21.035 14.815 21.035 12.4975C21.035 10.18 21.025 9.89 20.9825 8.98C20.94 8.0725 20.7975 7.4525 20.585 6.9075C20.3675 6.35 20.075 5.8725 19.6 5.4C19.125 4.925 18.65 4.635 18.0875 4.415C17.545 4.205 16.925 4.06 16.015 4.0175C15.1075 3.9775 14.8175 3.9675 12.5 3.9675Z"
      fill="white"
    />
    <path
      d="M12.5001 8.11749C10.0801 8.11749 8.11755 10.08 8.11755 12.5C8.11755 14.92 10.0801 16.8825 12.5001 16.8825C14.9201 16.8825 16.8826 14.92 16.8826 12.5C16.8826 10.08 14.9201 8.11749 12.5001 8.11749ZM12.5001 15.345C10.9301 15.345 9.65505 14.0725 9.65505 12.5C9.65505 10.9275 10.9301 9.65499 12.5001 9.65499C14.0701 9.65499 15.3451 10.9275 15.3451 12.5C15.3451 14.0725 14.0701 15.345 12.5001 15.345Z"
      fill="white"
    />
    <path
      d="M17.055 8.97C17.6211 8.97 18.08 8.51109 18.08 7.945C18.08 7.37891 17.6211 6.92 17.055 6.92C16.4889 6.92 16.03 7.37891 16.03 7.945C16.03 8.51109 16.4889 8.97 17.055 8.97Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'InstagramIcon',
  props: {
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>

<style>
</style>
